import { createContext, useContext, type ReactNode, type PropsWithChildren } from 'react';
import camelcaseKeys from 'camelcase-keys';
import type { Jsonifiable } from 'type-fest';

export type FlagSet = Record<string, NonNullable<Jsonifiable>>;

export const FlagsContext = createContext<FlagSet | null>(null);

interface FlagsProviderProps extends PropsWithChildren {
  flags: FlagSet;
}

export function FlagsProvider({ children, flags }: FlagsProviderProps): ReactNode {
  return <FlagsContext.Provider value={flags}>{children}</FlagsContext.Provider>;
}

export const useFlags = (): FlagSet => {
  const allFlags = useContext(FlagsContext);

  if (!allFlags) {
    throw new Error('useFlags must be used within a FlagsProvider');
  }

  return camelcaseKeys(allFlags);
};
